<template>
    <div></div>
</template>

<script>
export default {
    name: "ReplacementsStandard"
}
</script>

<style scoped>

</style>